import { ServiceHttpError } from 'base/service_error';
import { Button } from 'base/ui/button';
import { Dialog } from 'base/ui/dialog';
import { GenericErrorDialog, getLimitErrorDialog } from 'base/ui/error_dialogs';
import { Link } from 'base/ui/link';
import { TextRegularLight } from 'base/ui/typography';
import {
  authRouteToUrl,
  getCurrentLocationForRedirect,
} from 'blocks/auth/routes';
import { dashboardRouteToUrl } from 'blocks/dashboard/routes';
import React from 'react';

export function Project404Dialog() {
  const dashboardHref = dashboardRouteToUrl({ path: 'dashboard' });
  return (
    <Dialog
      title="Project not found"
      onClose={() => (window.location.href = dashboardHref)}
      buttons={
        <Button
          label="Return to Dashboard"
          variant="primary"
          href={dashboardHref}
          size="large"
        />
      }
    >
      <TextRegularLight>
        This project doesn’t exist or you don’t have permission to access it.
      </TextRegularLight>
      <TextRegularLight>
        You may need to <LoginLink /> to access it.
      </TextRegularLight>
    </Dialog>
  );
}

export function Project403Dialog() {
  const dashboardHref = dashboardRouteToUrl({ path: 'dashboard' });
  return (
    <Dialog
      title="You don’t have permission"
      onClose={() => (window.location.href = dashboardHref)}
      buttons={
        <Button
          label="Return to Dashboard"
          variant="primary"
          href={dashboardHref}
          size="large"
        />
      }
    >
      <TextRegularLight>
        You don’t have permission to access this project. Either this project is
        in a workspace you do not have access to or you need to <LoginLink /> to
        a different account to access it.
      </TextRegularLight>
    </Dialog>
  );
}

export function ProjectLoadErrorDialog({ error }: { error: unknown }) {
  const LimitErrorDialog = getLimitErrorDialog(error);
  if (LimitErrorDialog) return <LimitErrorDialog />;
  if (error instanceof ServiceHttpError && error.status === 404) {
    return <Project404Dialog />;
  }
  if (error instanceof ServiceHttpError && error.status === 403) {
    return <Project403Dialog />;
  }
  return (
    <GenericErrorDialog
      title="Error loading project"
      error={error}
      dismiss="reloadPage"
    />
  );
}

function LoginLink() {
  return (
    <Link
      target="_self"
      href={authRouteToUrl({
        path: 'login',
        context: { redirect: getCurrentLocationForRedirect() },
      })}
    >
      log in
    </Link>
  );
}
